'use client';

import ContentstackLivePreview from '@contentstack/live-preview-utils';
import { initializeContentStackSdk, isLpConfigValid } from './';
import type { TPage } from './types/pages';

let isInitialized = false;

/**
 * Initializes Contentstack Live Preview on the client side.
 * Should be called once when the app starts.
 */
export const initializeLivePreview = () => {
  if (isInitialized || typeof window === 'undefined') return;

  if (
    process.env.NEXT_PUBLIC_CONTENTSTACK_LIVE_PREVIEW === 'true' &&
    process.env.NODE_ENV !== 'production' &&
    isLpConfigValid()
  ) {
    const CStack = initializeContentStackSdk();

    ContentstackLivePreview.init({
      stackSdk: CStack,
      clientUrlParams: {
        host: process.env.NEXT_PUBLIC_CONTENTSTACK_API_HOST,
      },
      ssr: false,
    })?.catch((err) => console.error(err));

    isInitialized = true;
  }
};

/**
 * Client-side entry fetching with live preview support.
 * This handles the browser-specific preview mode checks.
 */
export const fetchEntryWithPreview = async (
  slug: string[] | string,
  serverEntry: TPage | undefined,
): Promise<TPage | undefined> => {
  if (typeof window === 'undefined') {
    return serverEntry;
  }

  // Initialize live preview if not already done
  initializeLivePreview();

  const { windowType } = ContentstackLivePreview?.config || {};

  if (windowType === 'preview') {
    return serverEntry;
  }

  return serverEntry;
};

// Export the live preview utilities for use in components
export const { onEntryChange } = ContentstackLivePreview;
export const contentStackLivePreview = ContentstackLivePreview;
